module.exports = __webpack_public_path__ + "img/no-completed.9fb51a52.png";